import type { FC, ReactNode } from 'react'

import { SDS_COLOR_WHITE } from '@s-group/design-system-tokens/web/tokens/colors.es6'
import { SDS_SPACE_SMALL } from '@s-group/design-system-tokens/web/tokens/space.es6'
import { minWidthFromTheme } from '@sok/design-system'
import { TopNavigationContainer } from 'components/Header/TopNavigation/TopNavigationContainer'
import { BaseLayout, PageContent } from 'components/layout/BaseLayout'
import { NotificationArea } from 'services/Notifications/NotificationArea'
import styled from 'styled-components'
import { OrderModificationNotificationContainer } from 'views/order/OrderModification/OrderModificationNotificationContainer'

import { CheckoutSummary } from './CheckoutSummary'

interface SummaryLayoutProps {
  toggleCustomerDetailsTick?: () => void
  validationErrorMsgs?: string[]
  placeOrderBtnClicked?: boolean
  'data-test-id': string
  filteredShoppingCartEmpty?: boolean
  children?: ReactNode
}

export const SummaryLayout: FC<SummaryLayoutProps> = (props) => (
  <BaseLayout
    data-test-id={props['data-test-id']}
    headerContent={<TopNavigationContainer />}
    mainContent={
      <>
        <OrderModificationNotificationContainer />
        <NotificationArea group="global" />
        <SummaryPageContent>
          <div data-test-id="summary-container">{props.children}</div>
        </SummaryPageContent>
      </>
    }
    sidebarContent={
      <SummaryContentContainer data-test-id="summary-side-container__desktop">
        <CheckoutSummary />
      </SummaryContentContainer>
    }
  />
)

const SummaryPageContent = styled(PageContent)(({ theme }) => ({
  backgroundColor: 'transparent',
  [minWidthFromTheme(theme).desktop]: {
    backgroundColor: SDS_COLOR_WHITE,
  },
}))

const SummaryContentContainer = styled.div(({ theme }) => ({
  backgroundColor: SDS_COLOR_WHITE,
  padding: ` ${SDS_SPACE_SMALL} 0`,
  height: '100%',
  [minWidthFromTheme(theme).desktop]: {
    width: '400px',
  },
}))
